import * as React from 'react';
import { observer, inject } from 'mobx-react';

import { Viewport, ViewLarge } from 'bernie-view';

import { SearchFormOptionsList, WizardMenu } from '.';

import { FlightsTripType } from '__generated__/api';
import { trackAnalytics } from 'utility';
import { AnalyticsStore } from 'bernie-core';
import { FlightsSearchFormTripTypeOption, FlightsSearchFormTripTypeOptionItem } from 'types/search/wizard';
import { SearchFormStore } from 'src/stores';
import { InteractableFieldComponentProps } from 'types/shared';

interface TripTypeOptionsProps extends InteractableFieldComponentProps {
  searchOption: FlightsSearchFormTripTypeOption;
  searchFormStore?: SearchFormStore;
  analytics?: AnalyticsStore;
}

interface TripTypeOptionsState {
  isOpen: boolean;
}

@inject('analytics', 'searchFormStore')
@observer
export class TripTypeOptions extends React.Component<TripTypeOptionsProps, TripTypeOptionsState> {
  public state = { isOpen: false };

  constructor(props: TripTypeOptionsProps) {
    super(props);
  }
  private menuListItemMapper(items: FlightsSearchFormTripTypeOptionItem[], analytics: AnalyticsStore) {
    const updateSelectedTripTypeReference = this.updateSelectedTripType;

    return items.map(item => ({
      attributes: {
        role: 'menuItem',
        tabindex: 0
      },
      onClick(): void {
        updateSelectedTripTypeReference(item.tripType, items, analytics);
      },
      className: 'uitk-list-item',
      label: item.label,
      typeAnchor: false
    }));
  }

  public updateSelectedTripType = (
    selectedTripType: FlightsTripType,
    items: FlightsSearchFormTripTypeOptionItem[],
    analytics: AnalyticsStore
  ): void => {
    const { searchFormStore } = this.props;
    const { selectedTripTypeOptionItem } = searchFormStore;

    if (selectedTripTypeOptionItem.tripType !== selectedTripType) {
      searchFormStore.setSelectedTripType(selectedTripType, 'tripType');

      const newSelectedTripTypeOptionItem = searchFormStore.selectedTripTypeOptionItem;
      trackAnalytics(newSelectedTripTypeOptionItem.tripTypeSelectedAnalytics, analytics);
    }
  };

  public toggleMenu = () => {
    const { searchOption, analytics, onFieldInteraction } = this.props;
    const { openAnalytics } = searchOption;
    const isOpen = !this.state.isOpen;

    isOpen && trackAnalytics(openAnalytics, analytics);

    onFieldInteraction && onFieldInteraction();

    return this.setState({ isOpen });
  };

  public render() {
    const { searchFormStore, searchOption, analytics } = this.props;
    const { icon, items } = searchOption;
    const loading = searchFormStore.searchForm.__typename === 'FlightsLoadingSearchForm';

    const mappedListItems = this.menuListItemMapper(items, analytics);
    const selectedItem = items.find(item => item.selected);

    return (
      <Viewport>
        <ViewLarge>
          <WizardMenu
            label={selectedItem.label}
            labelIcon={icon.id}
            toggleMenu={this.toggleMenu}
            isOpen={this.state.isOpen}
            dataTestId="flights-trip-type-options-toggle"
          >
            {!loading && <SearchFormOptionsList items={mappedListItems} />}
          </WizardMenu>
        </ViewLarge>
      </Viewport>
    );
  }
}
